module.exports = __webpack_public_path__ + "static/media/three-dots.fda95521.svg";